module.exports = __webpack_public_path__ + "static/media/Logo__Mitre.b1f8abd2.svg";